const RegistrationLookupValidationMessages = {
  english: {
    custom: {
      mileage: {
        required: 'Please enter your vehicle mileage',
        min_value: 'Mileage must be greater than 0'
      },
      registration: {
        required: 'Please enter your vehicle registration number'
      }
    }
  }
};

export default RegistrationLookupValidationMessages;
